import { authRoute } from 'helpers/routes'
import { injectExternalList, injectExternalReducer } from 'helpers/actions'
import moment from 'helpers/moment'

export const HomeRoute = (store) => Object.assign({}, authRoute(store), {
  authentication: false,
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/HomeContainer').default

      const date = moment('today', { castAsTimezone: true }).format()

      injectExternalReducer(store, 'auth')

      // only get orders for logged in users
      if (store && store.getState() && store.getState().auth && store.getState().auth.isLoggedIn) {
        injectExternalList(store, 'orders', date)
      }

      injectExternalList(store, 'options')
      injectExternalList(store, 'pricelist', date)
      injectExternalList(store, 'uoms')

      cb(null, Container)
    }, 'home')
  }
})

export default HomeRoute



// WEBPACK FOOTER //
// ./src/routes/Home/index.js